import React, {Component} from 'react'
import { LoaderLink,Media,Grid,Content } from '../../_core/components'
import { Entry } from '../../_core/models'
import {withSite} from '../../_core/utils/Site'
import Swipe from '../../_core/utils/Swipe'

import { TweenLite, TimelineMax, Sine, Expo, Power1, Power0 } from "gsap";

// Utils
import * as BreakPoints from '../../_core/utils/Breakpoints';

class Folio extends Component {

  tl;
  cur=0;
  playing=0;
  autoplay=1;
  timer = 0;
  items = [];
  constructor() {
    super()
    this.state = {cur:0};
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  componentDidMount = () =>{

      let tl = new TimelineMax({paused:true});

      let items = this.items || [];
      this.items = items;

      if(!items.length) return;

      tl.addLabel('label0');

      let h = window.innerHeight;

      items.forEach((item,ix)=>{

          let move = h * (ix+1);
          let nudge = h * 0.2;

          let nudgeRef = 'media'+(ix+1);

          let time = (h * 0.001);
          
          tl.to(this.refs.mover,time,{y:-(move),ease:Expo.easeInOut});
          //if(this.refs[nudgeRef]) tl.from(this.refs[nudgeRef],time,{y:500},"-="+(time));
          //tl.from(this.refs[nudgeRef],2,{x:200},"-="+time);

          tl.addLabel('label'+(ix+1));

      })

      if(items.lenth && (items[0].whiteText && items[0].whiteText != '0')) this.props.site.modify('dark');

      if(this.autoplay && items[0].timer && items[0].timer != '0'){
          let seconds = parseInt(items[0].timer) * 1000;
          this.timer = setTimeout(()=>{
              this.goTo(1);
          },seconds)

      }
      
      this.tl = tl;

  }

  next = () => {

        // Interaction disables autoplay
        clearTimeout(this.timer);
        this.autoplay = 0;

        let labelFrom = 'label'+this.cur;
        let labelTo = 'label'+(this.cur+1);

        // Nudge
        if(this.cur == (this.items.length - 1)){
          TweenLite.to(this.refs.mover,0.3,{y:"-=50",onComplete:()=>{

              TweenLite.to(this.refs.mover,0.5,{y:"+=50"})

          }})
          return;
        }

        this.goTo(this.cur + 1);
        return;

        return;
        // OLD WAY

        this.tl.tweenFromTo(labelFrom,labelTo);
        let _this = this;
        _this.cur++;
        this.setState({cur:this.cur});
  }

  prev = () => {

        // Interaction disables autoplay
        clearTimeout(this.timer);
        this.autoplay = 0;


        let labelFrom = 'label'+this.cur;
        let labelTo = 'label'+(this.cur-1);

        // Nudge
        if(!this.cur){
          TweenLite.to(this.refs.mover,0.3,{y:"+=50",onComplete:()=>{

              TweenLite.to(this.refs.mover,0.5,{y:"-=50"})

          }})
          return;
        }

        this.goTo(this.cur - 1);
        return;
        // OLD WAY

        this.tl.tweenFromTo(labelFrom,labelTo);
        let _this = this;

            _this.cur--;
        this.setState({cur:this.cur});

  }
  goTo = (ix) => {

        let _this = this;

        let labelFrom = 'label'+this.cur;
        let labelTo = 'label'+(ix);

        let h = this.refs.el.offsetHeight;
        let move = h * Math.abs((this.cur - ix));

        let time = (h * 0.001);

        let y = -(ix * h);

         let items = this.items || [];

         if(items[ix].whiteText && items[ix].whiteText != '0'){
                _this.props.site.modify('dark');
              }else{

                 _this.props.site.deModify('dark');

              }

              
        TweenLite.to(this.refs.mover,time,{y:y,ease:Expo.easeInOut,onComplete:()=>{
              
              
              

              if(_this.autoplay && items[ix].timer && items[ix].timer != '0'){

                let isLast = (items.length == (ix + 1));
               
                let seconds = parseInt(items[ix].timer) * 1000;
                _this.timer = setTimeout(()=>{
                    if(isLast) this.goTo(0);
                    else this.goTo(ix + 1);
                },seconds)
              }

        }})

        //this.tl.tweenFromTo(labelFrom,labelTo);
      

            _this.cur = ix;

            this.setState({cur:this.cur});


  }

  render () {

    if(!this.items.length) return null;

      return (
      <Swipe up={this.next} down={this.prev}>
      <div className="Folio" ref="el">
        <div className="Folio-head">

            <div className="Container">
            <div className="Folio-titles">

              {this.items.map((item,ix)=>{

                  let dir;
                  let active = (this.cur == ix) ? 'is-active ' : 'is-inactive';
                  if(this.cur > ix) dir = 'up';
                  if(this.cur < ix) dir = 'down';

                  return (
                  <div className={"Folio-title "+dir+' '+active}>

                      {(()=>{

                          if(item.slideTitle){

                            return (<Content modifier="folio" html={item.slideTitle} />)

                          }else{

                            return (

                              <Entry id={item.linkTo} render={(linkTo=>(
                                <h1>{linkTo.title}</h1>
                              ))} />

                            )

                          }

                      })()}
                      

                  </div>
                  )
              })}
            </div>
            </div>


        </div>
         <div data-layout-foot className="Folio-foot">
            <div data-layout-bl onClick={this.prev}>Prev</div>
            <div data-layout-br onClick={this.next}>Next</div>
         </div>
        <div data-layout ref="mover">
        {this.items.map((item,ix)=>(
            <div className="Folio-slide" data-layout-window style={{background:item.backgroundColour}}>
             <div className="Folio-media-wrapper" ref={'media'+ix}>
              <Entry id={item.linkTo} render={(linkTo=>(

                <LoaderLink to={linkTo.uri}>
                  <div className={"Folio-media Folio-media--"+item.style}>
                    <BreakPoints.Mobile>
                      <Media id={((item.mobileImage && item.mobileImage.length) ? item.mobileImage[0] : item.image[0])} className="Image--fit" fit={((item.style=='cover')?'cover':'contain')} />
                    </BreakPoints.Mobile>
                    <BreakPoints.Default>
                      <Media id={item.image[0]} className="Image--fit" fit={((item.style=='cover')?'cover':'contain')} />
                    </BreakPoints.Default>
                  </div>
                </LoaderLink>

              )) } />
              </div>
            </div>
        ))}
        
      
        </div>

        <ul className="Folio-pages">
        {this.items.map((item,ix)=>{
            let num = ix + 1;
            let text = (num < 10) ? '0'+num : num;
            return (
            <li className={"Folio-page "+((this.cur == ix) ? 'is-active' : 'is-inactive')}><a onClick={()=>{this.autoplay = 0;this.goTo(ix)}}>{text}</a></li>
            )
        })}
        </ul>

      </div>
      </Swipe>
      )
  }
}

export default withSite(Folio)



// WEBPACK FOOTER //
// ./src/js/components/Folio/Folio.jsx